import { useState, useEffect, useRef } from 'react';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { GoChevronDown } from 'react-icons/go'

import {
  Box, Text, Flex, Avatar, Button, Menu,
  MenuButton,
  MenuList,
  MenuItem,
  useToast,
  useOutsideClick,
  Grid
} from "@chakra-ui/react";
import { getThisUserIdToken, triggerLaunchdeckToast } from '../../global/helpers/global-helpers';
import { editDsrTeamMembers, resetEditDsrTeamMembers } from '../actions/dsr-actions';
import { checkIfExistingUser, resetCheckIfExistingUser } from '../actions/manage-dsr-member-actions';
import PageLoader from '../../global/components/helper-components/components/PageLoader';
import LaunchdeckButton from '../../global/components/helper-components/components/LaunchdeckButton';

import { combineAllDsrTeamMembersFromAllOrgs, getUserDetailsUsingDsrMembersArray } from '../../profile/helpers/user-helper';
import { displayUserTeamRolePermissions } from '../helpers/dsr-helpers';
import WarningTextMessage from '../../global/components/helper-components/components/WarningTextMessage';
import { getCoworkerList } from '../../profile/actions/get-active-coworker-list-actions';


function DsrAddInternalTeamMemberForm({
  dsrId,
  handleCloseModal,
  // Redux
  isDsrAdmin,
  editDsrTeamMembersOutcome,
  editingTeamInProgress, // TODO: UX Refactor this as there will be a split second lag
  dsrUserTeam,
  checkIfExistingUserOutcome,
  dsrTeamMembersRedux,
  orgActiveTeamMembers,
  isMobileView,
  // Actions
  editDsrTeamMembers,
  resetEditDsrTeamMembers,
  checkIfExistingUser,
  resetCheckIfExistingUser,
  getCoworkerList
}) {

  const toast = useToast();
  const orgTeamMembersRef = useRef(null)
  const teamPickerDropdownRef = useRef(null);
  const rolePickerDropdownRef = useRef(null);
  const thisUserIdToken = getThisUserIdToken();

  // Local States
  const [memberCardLocalState, setMemberCardLocalState] = useState({ nextActionPath: "" })
  const [orgName, setOrgName] = useState("")

  // Inputs
  const [emailInput, setEmailInput] = useState("")
  const [teamNameInputDisplay, setTeamNameInputDisplay] = useState("")
  const [updatedTeamStatus, setUpdatedTeamStatus] = useState(null)

  // Validation
  const [showIncompleteFormError, setShowIncompleteFormError] = useState(null)
  const [allInputsValidated, setAllInputsValidated] = useState(null)
  const [showNoTeamRoleError, setShowNoTeamRoleError] = useState(null)

  // UX management
  const [teamInput, setTeamInput] = useState("")
  const [showPickTeamDropdown, setShowPickTeamDropdown] = useState(false)
  const [buttonType, setButtonType] = useState('proceed') // Possible values: 'proceed' & 'no-further-steps'

  const [showMemberCard, setShowMemberCard] = useState(false)

  const [chosenRole, setChosenRole] = useState("") // Possible Values: "" / "Member" / "Admin"
  const [showPickRoleDropdown, setShowPickRoleDropdown] = useState(false)

  const [teamMemberPicked, setTeamMemberPicked] = useState("")
  const [isAlreadyDsrMember, setIsAlreadyDsrMember] = useState("")

  const [isAddingUser, setIsAddingUser] = useState(false)


  useOutsideClick({
    ref: teamPickerDropdownRef,
    handler: () => setShowPickTeamDropdown(false),
  })

  useOutsideClick({
    ref: rolePickerDropdownRef,
    handler: () => setShowPickRoleDropdown(false),
  })


  useEffect(() => {
    // Business Logic: If user is in Audience/Buyer team, they can only invite other users to the Audience / Buyer team
    // There will be no inputs to determine which team to add for Audience
    // This is required to pass validation checks 
    if (dsrUserTeam === 'audience') {
      setTeamInput('buyer-team')
    }

  }, [dsrUserTeam]);

  useEffect(() => {
    if (dsrTeamMembersRedux && !orgName) {
      const userProfile = getUserDetailsUsingDsrMembersArray(
        dsrTeamMembersRedux,
        thisUserIdToken
      )

      userProfile?.memberOrgName && setOrgName(userProfile.memberOrgName)
    }
  }, [dsrTeamMembersRedux, orgName, thisUserIdToken]);

  useEffect(() => {
    // Business Logic: Validate & allow user to click on Add user button
    if ((teamMemberPicked && teamInput === "seller-team" && chosenRole) || (teamMemberPicked && teamInput === "buyer-team")) {
      setAllInputsValidated(true)

    } else {
      setAllInputsValidated(false)
      setButtonType('proceed')
    }
  }, [teamMemberPicked, teamInput, chosenRole]);


  useEffect(() => {
    if (editDsrTeamMembersOutcome) {
      const { updatedTeamMembers } = editDsrTeamMembersOutcome || {}

      if (updatedTeamMembers) {
        toast(
          triggerLaunchdeckToast({
            useCase: "show-success-state",
            label: "Your co-worker has been added to the Room successfully",
            isMobileView
          })
        )

        resetForm()

      } else if (!updatedTeamMembers) {
        // Case: Duplicated email user
        setUpdatedTeamStatus(updatedTeamMembers)
      }

      resetEditDsrTeamMembers()
    }
  }, [editDsrTeamMembersOutcome, resetEditDsrTeamMembers]);

  useEffect(() => {
    if (checkIfExistingUserOutcome) {
      const { nextActionPath, userCardData } = checkIfExistingUserOutcome || {};

      setMemberCardLocalState({
        ...memberCardLocalState,
        nextActionPath,
        ...userCardData && { userCardData }
      })

      if (nextActionPath === "show-cannot-add-user-card") {

        toast(
          triggerLaunchdeckToast({
            useCase: "show-error-state",
            duration: "9000",
            bannerText: "User cannot be added to this Room",
            label: "This user has been deactivated or has left their organization",
            isMobileView
          })
        )

        resetForm()

      } else if (nextActionPath === "show-user-is-already-member") {
        setIsAlreadyDsrMember(true)
        setButtonType('no-further-steps')
      } else {
        if (dsrTeamMembersRedux && userCardData) {
          const isDsrMember = getUserDetailsUsingDsrMembersArray(dsrTeamMembersRedux, userCardData.memberIdToken)
          const isActiveMember = isDsrMember?.memberStatus === "active"
          setIsAlreadyDsrMember(isActiveMember || false)
          isActiveMember && setButtonType('no-further-steps')
        }

        setShowMemberCard(true)

      }

      resetCheckIfExistingUser()
    }
  }, [checkIfExistingUserOutcome, resetCheckIfExistingUser, memberCardLocalState, dsrTeamMembersRedux])

  useEffect(() => {
    if (!orgActiveTeamMembers && !orgTeamMembersRef.current) {
      getCoworkerList()
      orgTeamMembersRef.current = true
    }

  }, [orgActiveTeamMembers])


  const renderMemberCard = () => {
    if (showMemberCard) {
      const { userCardData } = memberCardLocalState || {};
      const { memberFirstName, memberLastName, memberEmail, memberProfilePicSrc, memberOrgName, memberOrgTitle } = userCardData || {};

      const credentials = (memberOrgName && memberOrgTitle) ? memberOrgTitle + ', ' + memberOrgName : memberOrgName ? memberOrgName : memberEmail ? memberEmail : emailInput;
      const memberFullName = (memberFirstName && memberLastName) ? (memberFirstName + ' ' + memberLastName).trim() : memberFirstName ? memberFirstName.trim() : memberLastName ? memberLastName.trim() : "";
      return (
        <>
          <Flex justify="flex-start" align='center' className='flip-in-hor-bottom' p='1em' bg='white' border='1px solid' borderColor='gray.300' rounded='0.25em'>
            {memberProfilePicSrc ?
              <Avatar width='3.8em' height='3.8em' bg='gray.100' color='gray.700' src={memberProfilePicSrc} />
              :
              <Box boxSize='2.6em' rounded='100%' border='1px dashed' borderColor='gray.500' /> // TODO: Review a better fallback image
            }
            <Box ml='1em' textAlign='left'>
              <Box fontSize='0.875em' lineHeight='1.375em' fontWeight='500' color='brandDark.500'>{memberFullName || ""}</Box>
              <Box fontSize='0.75em' lineHeight='1em' fontWeight='400' color='gray.500' mt='0.2em'>{credentials}</Box>
            </Box>
          </Flex>
        </>
      )
    }
  }


  const resetForm = () => {
    setEmailInput("")
    setTeamInput("")
    setTeamNameInputDisplay("")
    setChosenRole("")
    setButtonType("proceed")
    setShowMemberCard(false)
    setMemberCardLocalState({ nextActionPath: "" })

    setTeamMemberPicked("")
    setIsAlreadyDsrMember("")
    setIsAddingUser(false)
  }


  const handleAddMemberButton = () => {

    if (allInputsValidated === true && teamMemberPicked) {
      const updateParams = {
        teamToUpdate: teamInput,
        updateAction: 'add-member',
        inviteeEmail: teamMemberPicked.email,
        chosenRole: chosenRole ? chosenRole : 'Member', // defaults to Member (no input required for Guests adding other guests) 
        firstName: teamMemberPicked.memberFirstName,
        lastName: teamMemberPicked.memberLastName,
        userId: teamMemberPicked.userId
      }
      // 

      handleEditDsrMembers(updateParams);

      // TODO UX: Then loading state, show adding is successful, and have a state that shows successful, OK button to bring back to team tab to show pending invite user
      setIsAddingUser(true)
    }

  }

  // UX: Pick Team
  const handlePickTeamOption = (teamToUpdate) => {
    setTeamInput(teamToUpdate);
    !!showNoTeamRoleError && setShowNoTeamRoleError(false)

    if (teamToUpdate === 'buyer-team') {
      setTeamNameInputDisplay("Guests")
      setChosenRole(isDsrAdmin ? "" : "Member")
      setShowPickRoleDropdown(false)
    } else if (teamToUpdate === 'seller-team') {
      setTeamNameInputDisplay("Hosts")
      setChosenRole(isDsrAdmin ? "" : "Member")
    }

    setShowIncompleteFormError(false);
  }

  const handlePickRoleOption = (pickedRole) => {
    setChosenRole(pickedRole)
    !!showNoTeamRoleError && setShowNoTeamRoleError(false)
  }

  const handlePickOrgTeamMemberOption = (pickedMember) => {
    setTeamMemberPicked(pickedMember)
  }

  const handleClickProceedButton = () => {
    let allowProceed = true;

    if (!teamInput || (teamInput === "seller-team" && !chosenRole)) {
      setShowNoTeamRoleError(true)
      allowProceed = false
    }

    if (allowProceed) {
      if (teamMemberPicked) {
        checkIfExistingUser(teamMemberPicked.email, dsrId)
      }
    }
  }

  const displayDuplicateMemberDetected = () => {
    const handleButtonClick = () => {
      handleCloseModal()
      setUpdatedTeamStatus("")
      resetEditDsrTeamMembers()
    }

    return (
      <Box my='1em' w='100%' bg='gray.50' rounded="0.25em" p='1em'>
        <Box textAlign={'left'} fontSize='0.875em'>{teamMemberPicked.memberName} has already joined this Room. You won't have to do anything else!</Box>
        <Flex w='100%' justify={['center', 'flex-start']} mt='1.5em'>
          <LaunchdeckButton bg='brand.500' fontSize='0.8em' py='0.4em' color='white' onClick={() => handleButtonClick()} label='OK' />
        </Flex>
      </Box>
    )
  }

  const handleEditDsrMembers = async (updateParams) => {

    const updateTeamParams = { dsrId, updateParams }
    await editDsrTeamMembers(updateTeamParams);
  }

  const renderOrgTeamMemberPicker = (optionsAvailable) => {

    const combinedTeamMembersArray = combineAllDsrTeamMembersFromAllOrgs(dsrTeamMembersRedux);
    const renderMemberOptionCards = () => {
      const renderCoworkerOptions = optionsAvailable?.length > 0 ? optionsAvailable?.map((member, memberIndex) => {
        const { userId, memberName, memberProfilePicSrc } = member || {}

        const excludeOption = combinedTeamMembersArray.some(
          (obj) => obj.userId === userId && obj.memberStatus !== 'active' && obj.userStatus === 'active'
        );

        return (
          <MenuItem key={`org_team_member_${memberIndex}${userId}`} minH='100%' p='0.5em 1em' gap={8} onClick={() => !excludeOption && handlePickOrgTeamMemberOption(member)}>
            <Avatar h="2.6em" w="2.6em" name={memberName} bg='gray.100' color='gray.700' src={memberProfilePicSrc} />
            <span><Box fontSize='0.875em' >{memberName}</Box> </span> {excludeOption && <Box color='white' fontSize='0.65em' px='1em' py='0.2em' rounded='1em' bg='brandGreen.500'> In Room</Box>}
          </MenuItem>
        )
      }

      )
        : null;

      return renderCoworkerOptions

    }

    return (
      <>
        <Box w='100%' position='relative' zIndex='24'>
          <Box bg='whiteAlpha.500' fontWeight='600' fontSize='0.7em' position='absolute' bottom='2.6em' left='1em' zIndex='25'> Whom to add </Box>
          <Menu>
            <MenuButton as={Button} fontSize='0.875em' fontWeight='400' justify='space-between' rightIcon={<GoChevronDown />}
              bg='white'
              border='1px solid #E2E8F0'
              rounded='0.25em'
              height='2.6em'
              minW='18em'
              w="100%"
              _hover={{ bg: "none" }}
            >

              <Flex justify='flex-start' align='center' gap={8}>
                {teamMemberPicked && <Avatar h="3em" w="3em" name={teamMemberPicked.memberName} bg='gray.100' color='gray.700' src={teamMemberPicked.memberProfilePicSrc} />}
                <span><Box fontSize='1em' p='4px 16px 4px 4px' color={teamMemberPicked ? 'brandDark.500' : 'gray.300'}> {teamMemberPicked ? teamMemberPicked.memberName : "Pick one"}</Box> </span>
              </Flex>

            </MenuButton>
            <MenuList minW='16em' maxH="12.5em" overflowY="auto" zIndex='10'>

              {renderMemberOptionCards()}

            </MenuList>
          </Menu>
        </Box>
      </>
    )
  }



  const renderCtaButton = () => {
    switch (buttonType) {
      case ('proceed'): {
        return (
          <LaunchdeckButton bg={allInputsValidated ? 'brand.500' : 'gray.300'} w='100%' color='white' minW='3em' cursor={"pointer"} onClick={() => handleClickProceedButton()} label='Next' />
        )
      }
      case ('no-further-steps'): {
        return (
          <Flex>
            <LaunchdeckButton noHover bg='brand.500' color='white' minW='3em' onClick={() => resetForm()} label='OK' />
          </Flex>
        )
      }
      default: {
        return null;
      }
    }
  }

  if (editingTeamInProgress) {
    return <PageLoader />
  } else {

    if (orgActiveTeamMembers) {
      const optionsAvailable = Array.isArray(orgActiveTeamMembers) ? orgActiveTeamMembers.filter(user => user.userId !== thisUserIdToken) : [];
      // Check which members are already currently DSR members
      const isOnePersonTeam = (orgActiveTeamMembers?.length === 1 && orgActiveTeamMembers[0].userId === thisUserIdToken) ? true : false
      const noOptionsAvailable = (optionsAvailable?.length === 0) ? true : false

      if (noOptionsAvailable) {
        return (
          <Flex direction='column' justify='flex-start' mt='2em' mb='1em' p='1em' border='1px dotted #E5EAEF' rounded='0.5em' bg='gray.50' w='100%' h={['auto', '100%']}>
            <Box px='1em'>
              <Box fontSize='0.875em' my='0.5em' py='0.25em' textAlign='left' letterSpacing={'1px'} borderTop='1px solid' borderBottom='1px solid' borderColor='gray.700'>
                {isOnePersonTeam ? 'No other members are in your team' : 'All coworkers are in this Room'}
              </Box>
              <Box mt='1.5em' fontSize='0.8em' textAlign='left' whiteSpace={'pre'}>
                To add more coworkers to your team, go to <i>{`Account > Organization > Team`}</i>
              </Box>
              <Box mt='0.25em' fontSize='0.8em' textAlign='left' whiteSpace={'pre'}>
                Then, click on <i>Add Users</i>
              </Box>
            </Box>
          </Flex>
        )
      }

      return (
        <Flex direction='column' justify={['flex-start', 'flex-start', 'center', 'center']} align='center' mt='2em' mb='1em' p='1em' border='1px dotted #E5EAEF' rounded='0.5em' bg='gray.50' w='100%' h={['auto', 'auto', '100%', '100%']}>
          <Flex mb='1em' justify='flex-start' w='100%' fontSize='0.875em' color='brandDark.500' px='1em' fontWeight='600'>Add someone from {orgName || "your Organization team"}</Flex>

          {
            (isAlreadyDsrMember || updatedTeamStatus === false)
              ? displayDuplicateMemberDetected() :
              showMemberCard
                ? <Box w='100%' px='1em'>
                  <Grid templateColumns={["1fr", "1fr 1fr"]} templateRows={["1fr 1fr", "1fr"]} gap='1em' align='center'>
                    {renderMemberCard()}
                    <Flex gap='1em' className='fade-in'>
                      <Flex direction='column' flex="1" justify='center' align='center'
                        bg='white'
                        rounded='0.25em' border='1px solid' borderColor='gray.300'
                      >
                        <Box fontSize='0.7em' color='brand.500' fontWeight='600'>TEAM</Box>
                        <Box fontSize='0.8em'>{teamNameInputDisplay || "Guest"}</Box>
                      </Flex>
                      <Flex direction='column' flex="1" justify='center' align='center'
                        bg='white'
                        rounded='0.25em' border='1px solid' borderColor='gray.300'
                      >
                        <Box fontSize='0.7em' color='brandPink.500' fontWeight='600'>ROLE</Box>
                        <Box fontSize='0.8em'>{chosenRole || "Member"}</Box>
                      </Flex>
                    </Flex>
                  </Grid>

                  <Flex w='100%' mt='2em' gap='1em' align='center' justify='flex-end'>
                    <LaunchdeckButton noHover bg='gray.200' color='brandDark.500' fontSize='0.8em' onClick={() => resetForm()} label='Back' />
                    <LaunchdeckButton bg='brand.500' color='white' fontSize='0.8em' loadingLogic={isAddingUser} onClick={() => allInputsValidated && handleAddMemberButton()} label='Add to Room' />
                  </Flex>

                </Box> :
                <>
                  <Box w='100%' p={["1.5em 0", "1.5em 1em"]} align='center' gap='1em' className='fade-in'>
                    <Box w='100%' mt='1em'>
                      {(dsrUserTeam === 'host') &&
                        <Box >
                          <Flex w='100%' direction='column' gap={'1.5em'}>
                            {renderOrgTeamMemberPicker(optionsAvailable)}

                            <Flex direction={['column', 'row']} gap='1.5em'>
                              {!isAlreadyDsrMember &&
                                <Box w='100%' position='relative' flex="1" zIndex='22'>
                                  <Box bg='whiteAlpha.500' fontWeight='600' fontSize='0.7em' position='absolute' bottom='3em' left='1em' zIndex='23'> Team </Box>
                                  <Flex className='user-invite-dropdown-menu' onClick={() => setShowPickTeamDropdown(!showPickTeamDropdown)} ref={teamPickerDropdownRef}>
                                    {teamNameInputDisplay ? <Box color='brandDark.500' fontSize='0.875em'>{teamNameInputDisplay}</Box> : <Box color="gray.300" fontSize='0.875em'>Pick one</Box>}
                                    <Box as={GoChevronDown} boxSize="0.75em" color="gray.500" />
                                    <Box className='user-invite-dropdown-menu__dropdown' display={(showPickTeamDropdown) ? 'inline-block' : 'none'}>
                                      <Box className='user-invite-dropdown-menu__dropdown-option-display' onClick={() => handlePickTeamOption('seller-team')}>{"Hosts"}</Box>
                                      <Box className='user-invite-dropdown-menu__dropdown-option-display' onClick={() => handlePickTeamOption('buyer-team')}>{"Guests"}</Box>
                                    </Box>
                                  </Flex>
                                </Box>

                              }
                              {
                                (dsrUserTeam === 'audience') &&
                                <Box flex="1" w='100%' position='relative' className='fade-in' zIndex='20'>
                                  <Box bg='whiteAlpha.500' fontWeight='600' fontSize='0.7em' position='absolute' bottom='3em' left='1em' zIndex='21'> Role </Box>
                                  <Flex className='user-invite-display-only-menu'>
                                    <Box color='brandDark.500'>Guests</Box>
                                  </Flex>
                                </Box>
                              }

                              {
                                (teamInput === 'seller-team' && isDsrAdmin) &&
                                <Box flex="1" w='100%' position='relative' className='fade-in' zIndex='20'>
                                  <Box bg='whiteAlpha.500' fontWeight='600' fontSize='0.7em' position='absolute' bottom='3em' left='1em' zIndex='21'> Role </Box>
                                  <Flex className='user-invite-dropdown-menu' onClick={() => setShowPickRoleDropdown(!showPickRoleDropdown)} ref={rolePickerDropdownRef}>
                                    {chosenRole ? <Box color='brandDark.500' fontSize='0.875em'>{chosenRole}</Box> : <Box color="gray.300" fontSize='0.875em'>Choose Role</Box>}
                                    <Box as={GoChevronDown} boxSize="0.75em" color="gray.500" />
                                    <Box className='user-invite-dropdown-menu__dropdown' display={(showPickRoleDropdown) ? 'inline-block' : 'none'}>
                                      <Box className='user-invite-dropdown-menu__dropdown-option-display' onClick={() => handlePickRoleOption('Member')}>{"Member"}</Box>
                                      <Box className='user-invite-dropdown-menu__dropdown-option-display' onClick={() => handlePickRoleOption('Admin')}>{"Admin"}</Box>
                                    </Box>
                                  </Flex>

                                </Box>
                              }
                            </Flex>
                          </Flex>
                        </Box>
                      }


                      <Box mt='0.5em' textAlign='left'>
                        <WarningTextMessage fontSize='0.7em' errorLogic={showNoTeamRoleError} message='Please decide whether they should be in the host or guest team & their role here' />
                      </Box>

                      {displayUserTeamRolePermissions({ dsrUserTeam, teamInput, chosenRole, isMobileView })}

                    </Box>
                  </Box>

                  <Flex w='100%' height='auto'>
                    {showIncompleteFormError && <Text textAlign='center' color='brandPink.500' fontSize='0.8em'>Please ensure all the fields are filled in </Text>}
                  </Flex>
                  <Flex w='100%' justify={["center", "flex-end"]} mt={['0em', '2em']} pb={['1em', '0em']} px='1em'>
                    <Box w='100%' maxW={['100%', '5em']} >
                      {renderCtaButton()}
                    </Box>
                  </Flex>
                </>
          }
        </Flex>
      )
    } else return null
  }
}


function mapStateToProps(state) {
  return {
    isDsrAdmin: state.dsrAdmin.isDsrAdmin,
    editDsrTeamMembersOutcome: state.editDsrTeamMembersOutcome.results.data,
    editingTeamInProgress: state.editDsrTeamMembersOutcome.isLoading,
    dsrUserTeam: state.dsrUserTeam.userTeam,
    checkIfExistingUserOutcome: state.checkIfExistingUserOutcome.results.data,
    dsrTeamMembersRedux: state.dsrTeamMembers.members,
    orgActiveTeamMembers: state.userActiveOrgTeamMembers.orgActiveTeamMembers,
    isMobileView: state.mobileViewMode.isMobileView,
  };
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      editDsrTeamMembers,
      resetEditDsrTeamMembers,
      checkIfExistingUser,
      resetCheckIfExistingUser,
      getCoworkerList
    },
    dispatch,
  )


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(DsrAddInternalTeamMemberForm));
